import script from "./EntertainmentPlan.vue?vue&type=script&lang=ts&setup=true"
export * from "./EntertainmentPlan.vue?vue&type=script&lang=ts&setup=true"

import "./EntertainmentPlan.vue?vue&type=style&index=0&id=6db896de&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db896de"]])

export default __exports__